import React, { useState, useEffect } from 'react';
import { fetchCategoryName, fetchItemInfo } from '../bridge';
import PortfolioItem from './PortfolioItem';
import '../styles/Category.css'

const PortfolioLayout = ({ supabase, userEmail, uploaderId }) => {
  const [images, setImages] = useState([]);
  const [categoryName, setCategoryName] = useState('');
  const [itemInfo, setItemInfo] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const previousCategoryName = await fetchCategoryName({ userEmail, categoryId: uploaderId });
        if (previousCategoryName) setCategoryName(previousCategoryName);

        await fetchImages();
      } catch (error) {
        console.error('Error fetching category data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [userEmail, uploaderId]);

  const fetchImages = async () => {
    if (!userEmail) {
      console.error('User email is missing.');
      return;
    }

    try {
      const { data, error } = await supabase.storage.from('images').list(`${userEmail}/${uploaderId}`);
      if (error) {
        console.error('Error fetching images:', error);
        return;
      }

      if (Array.isArray(data) && data.length > 0) {
        const imageData = data.map(file => ({
          id: file.name,
          url: supabase.storage.from('images').getPublicUrl(`${userEmail}/${uploaderId}/${file.name}`).data.publicUrl,
          name: file.name,
        }));

        setImages(imageData);
        await retrieveItemInfo(imageData);
      } else {
        setImages([]);
        setItemInfo([]);
        console.log('No files found in the specified folder.');
      }
    } catch (error) {
      console.error('Error fetching images:', error);
    }
  };

  const retrieveItemInfo = async (imageData) => {
    try {
      const itemInfoArray = await Promise.all(
        imageData.map(async (image) => {
          const itemInfo = await fetchItemInfo({ userEmail, categoryId: uploaderId, imageIndex: image.id });
          return itemInfo || { item_name: '', item_description: '' };
        })
      );

      setItemInfo(itemInfoArray);
    } catch (error) {
      console.error('Error fetching item info:', error);
    }
  };

  if (loading) {
    return <div className='loading-spinner'>Loading...</div>;
  }

  return (
    <div className='category-container'>
      <h2 className='category-name'>{categoryName}</h2>
      <div className='image-row'>
        {images.map((image, index) => (
          <PortfolioItem key={index} image={image} index={index} itemInfo={itemInfo} />
        ))}
      </div>
    </div>
  );
};

export default PortfolioLayout;